// removed by extract-text-webpack-plugin
module.exports = {"form__button":"form__button___24qSh","loading":"loading___52n-Q"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Admin/UsersManagement/UserEdit/Form/styles.module.scss
// module id = 2696
// module chunks = 0